import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "magnifying-glass-24", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", d: "M10 2a8 8 0 0 1 6.135 13.135l5.114 5.116a.706.706 0 0 1-.998.998l-5.116-5.114A8 8 0 1 1 10 2Zm0 1.412a6.588 6.588 0 1 0 0 13.176 6.588 6.588 0 0 0 0-13.176Z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
